// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyResultGuide_container__DFEr5"};